import { UtilService } from '../../../services/util.service';
import { AlertService } from '../../../services/alert.service';
import { Component, OnInit, NgZone } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { Router } from '@angular/router';;
import { Reservation } from '../../../models/reservation.model';

@Component({
  selector: 'app-reservation-owner',
  templateUrl: './reservation-owner.page.html',
  styleUrls: ['./reservation-owner.page.scss'],
})
export class ReservationOwnerPage implements OnInit {

  filter= 1

  constructor(public db: DBService, private router: Router, private ngZone: NgZone, public util: UtilService, private alert: AlertService) { }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }
    this.util.reservationUI = 'overview'

    //Delete old reservations
    let oldReservations = this.db.reservationList[this.db.currentReservationListKey].reservations.filter(reservation => {
      return reservation.date < new Date().getTime() - 259200000 //= 3 Tage
    })

    for (let reservation of oldReservations) {
      this.db.reservationList[this.db.currentReservationListKey].reservations = this.util.deleteFromArray(this.db.reservationList[this.db.currentReservationListKey].reservations, reservation)
    }
    if (oldReservations && oldReservations.length > 0)
      this.db.updateReservationList(this.db.currentReservationListKey);
  }

  segmentChanged(ev: any) {
    this.filter = +ev.detail.value
  }

  back() {
    if (this.util.reservationUI == 'create') {
      this.util.reservationUI = 'overview'
    } else {
      this.ngZone.run(() => this.router.navigate(['/owner-home']))
    }
  }

  deny(reservation: Reservation) {
    this.alert.presentAlertConfirm(this, (ref) => {
      reservation.denied = true;
      reservation.deniedReason = "Leider nicht verfügbar. Vielen Dank.";
      this.db.updateReservationList(this.db.currentReservationListKey)
    }, 'Reservierung ablehnen?', 'Möchtest du diese Reservierung wirklich ablehnen?')
  }

  confirm(reservation: Reservation) {
    this.alert.presentAlertConfirm(this, (ref) => {
      reservation.confirmed = true;
      this.db.updateReservationList(this.db.currentReservationListKey)
    }, 'Reservierung bestätigen?', 'Möchtest du diese Reservierung wirklich bestätigen?')
  }

  getReservationCssClass(reservation: Reservation) {
    if (reservation.denied) return "denied"
    if (reservation.confirmed) return "confirmed"
    return "";
  }

  get reservations() {
    let _this = this
    let filteredReservations = this.db.reservationList[this.db.currentReservationListKey].reservations.filter(function (a: Reservation) {
      if (_this.filter == 1) {
        return true;
      }
      if (_this.filter == 2) {
        return !a.denied;
      }

      return a.confirmed;
    });

    return filteredReservations.sort(function (a: Reservation, b: Reservation) {
      if (a.date < b.date) {
        return 1;
      }
      if (a.date > b.date) {
        return -1;
      }

      return 0;
    });
  }

  createNewReservation() {
    this.util.reservationUI = 'create'
  }

}
